import { ELEVATOR_CONTROLS } from "../../constants/action";
import { ControlOption } from "./scheduledActionTypes";

/**
 * Given a Control enum numeric value, return the numeric value of its
 * lock/unlock complement, or undefined if no complement exists.
 *
 * Pairing rule: names ending in "Lock" pair with the same-prefix "Unlock",
 * and vice versa. All lookups are done by generated name — no hardcoded ints.
 */
export function pairedStopControl(value: number): number | undefined {
  const entry = ELEVATOR_CONTROLS.find((c) => c.id === value);
  if (entry === undefined) return undefined;
  const { name } = entry;

  let complementName: string;
  if (name.endsWith("Lock")) {
    complementName = `${name.slice(0, -4)}Unlock`;
  } else if (name.endsWith("Unlock")) {
    complementName = `${name.slice(0, -6)}Lock`;
  } else {
    return undefined;
  }

  const complement = ELEVATOR_CONTROLS.find((c) => c.name === complementName);
  return complement?.id;
}

/**
 * Build a ControlOption[] from the generated ELEVATOR_CONTROLS list,
 * augmenting each entry with its lock/unlock complement as defaultStopValue.
 */
export function buildControlOptions(): ControlOption[] {
  return ELEVATOR_CONTROLS.map(({ name, id }) => ({
    value: id,
    label: name,
    defaultStopValue: pairedStopControl(id),
  }));
}
